var React = require('react');

function SearchIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.65928 0.5C9.62946 0.5 11.519 1.28265 12.9121 2.67578C14.3052 4.06891 15.0879 5.95839 15.0879 7.92857C15.0879 9.76857 14.4136 11.46 13.305 12.7629L13.6136 13.0714H14.5164L20.2307 18.7857L18.5164 20.5L12.8021 14.7857V13.8829L12.4936 13.5743C11.1907 14.6829 9.49928 15.3571 7.65928 15.3571C5.68911 15.3571 3.79962 14.5745 2.40649 13.1814C1.01336 11.7882 0.230713 9.89875 0.230713 7.92857C0.230713 5.95839 1.01336 4.06891 2.40649 2.67578C3.79962 1.28265 5.68911 0.5 7.65928 0.5ZM7.65928 2.78571C4.80214 2.78571 2.51643 5.07143 2.51643 7.92857C2.51643 10.7857 4.80214 13.0714 7.65928 13.0714C10.5164 13.0714 12.8021 10.7857 12.8021 7.92857C12.8021 5.07143 10.5164 2.78571 7.65928 2.78571Z","fill":"#666666"}));
}

SearchIcon.defaultProps = {"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none"};

module.exports = SearchIcon;

SearchIcon.default = SearchIcon;
